import Templete from "../../template/Template";
import CadastroProcesso from "./CadastroProcesso";

export default function PageCadastroProcesso() {
    return (
        <Templete menuActive="processos">
            <CadastroProcesso />
        </Templete>
    );
}